<template>
  <div class="grid" @click.stop="">
    <div class="col-12">
      <Dialog
        :header="header"
        :visible.sync="displayModal"
        :style="{ width: '350px' }"
        :modal="true"
        :contentStyle="{ overflow: 'visible' }"
        @hide="cancel"
      >
        <Errors v-show="this.errores.length > 0" :errors="this.errores" />
        <div class="p-inputgroup">
          <input
            type="file"
            id="documento"
            ref="ficheroASubir"
            @change="handleFileUpload()"
          />
        </div>
        <template #footer>
          <Button
            :label="$t('common.buttons.save')"
            icon="pi pi-save"
            @click="upload()"
            autofocus
          />
          <Button
            :label="$t('common.buttons.cancel')"
            icon="pi pi-times"
            @click="cancel()"
            class="p-button-secondary"
          />
        </template>
      </Dialog>
    </div>
  </div>
</template>


<script>
import Errors from "@/components/utilidades/Errors.vue";

export default {
  name: "UploadDocument",
  components: {
    Errors: Errors,
  },
  props: ["header", "clave", "display", "query"],
  data() {
    return {
      displayModal: this.display,
      fileToUpload: "",
      filename: "",
      fileBase64: null,
      errores: [],
    };
  },
  methods: {
    upload() {
      this.$apollo
        .mutate({
          mutation: this.query,
          variables: {
            uploadDocumentoRequest: {
              filename: this.filename,
              base64: this.fileBase64,
              clave: this.clave,
            },
          },
          update(data) {
            return data;
          },
        })
        .then(() => {
          this.errores = [];
          this.displayModal = false;
          this.$emit("subidaFicheroFinalizada", true);
        })
        .catch((exception) => {
          this.errores = [];
          exception.graphQLErrors.forEach((error) => {
            this.errores.push(
              this.$i18n.t("documento.errores." + error.message)
            );
          });
        });
    },
    cancel() {
      this.errores = [];
      this.displayModal = false;
      this.$emit("subidaFicheroFinalizada", true);
    },
    handleFileUpload() {
      this.fileToUpload = this.$refs.ficheroASubir.files[0];
      if (this.fileToUpload != null && this.fileToUpload != undefined) {
        var reader = new FileReader();
        reader.readAsDataURL(this.fileToUpload);
        let self = this;
        reader.onload = function () {
          self.filename = self.fileToUpload.name;
          self.fileBase64 = reader.result;
        };
        reader.onerror = function (error) {
          console.error(error);
          self.filename = "";
          self.fileBase64 = null;
        };
      }
    },
  },
};
</script>


<style lang="scss" scoped>
</style>